import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    Widget,
    FormSubviewFieldWidget,
    ViewType
} from '@kunlun/dependencies';
import { exportExcelFile } from '@/custom-widget/MindMap/utils/excel';

/**
 * 纸品直发让利系数明细导出组件
 * 功能：导出纸品类型、子品牌、让利系数、是否发货即开单四个字段
 * 逻辑：如果有勾选按照勾选导出，如果没有勾选全部导出
 * 
 * 注册方式：通过 model 自动匹配子视图的导出按钮
 */

// 导出逻辑的共享实现
const handleExport = async (widget: any) => {
    try {
        console.log('\n========================================');
        console.log('纸品让利系数明细导出 - 开始');
        console.log('========================================\n');
        
        // 从 dataSource 或 parentDataSource 获取数据
        let allData: any[] = [];
        let checkedData: any[] = [];
        
        // 尝试多种方式获取数据
        console.log('--- 尝试获取数据 ---');
        
        // 方式1: 从 dataSource 获取
        if (Array.isArray(widget.dataSource) && widget.dataSource.length > 0) {
            allData = widget.dataSource;
            console.log('从 dataSource 获取数据, 数量:', allData.length);
        }
        
        // 方式2: 从 parentDataSource 获取
        if (allData.length === 0 && Array.isArray(widget.parentDataSource) && widget.parentDataSource.length > 0) {
            allData = widget.parentDataSource;
            console.log('从 parentDataSource 获取数据, 数量:', allData.length);
        }
        
        // 方式3: 向上查找带有 value 的组件
        if (allData.length === 0) {
            let parentWidget = widget.getParentWidget?.();
            let depth = 0;
            while (parentWidget && depth < 20) {
                const typeName = parentWidget?.constructor?.name || 'unknown';
                console.log(`[查找第${depth}层] 组件类型: ${typeName}`);
                
                if (Array.isArray(parentWidget.value) && parentWidget.value.length > 0) {
                    allData = parentWidget.value;
                    console.log('从父组件 value 获取数据, 数量:', allData.length);
                    break;
                }
                
                if (Array.isArray(parentWidget.dataSource) && parentWidget.dataSource.length > 0) {
                    allData = parentWidget.dataSource;
                    console.log('从父组件 dataSource 获取数据, 数量:', allData.length);
                    break;
                }
                
                parentWidget = parentWidget.getParentWidget?.();
                depth++;
            }
        }
        
        // 获取勾选数据：action widget 的 activeRecords 即当前表格的勾选行
        console.log('\n--- 尝试获取勾选数据 ---');
        checkedData = Array.isArray(widget.activeRecords) ? widget.activeRecords : [];
        console.log('勾选数据数量:', checkedData.length);

        // 如果有勾选按照勾选导出，如果没有勾选全部导出
        const dataToExport = (checkedData && checkedData.length > 0) ? checkedData : allData;
        
        console.log('\n--- 导出数据统计 ---');
        console.log('待导出数据数量:', dataToExport?.length || 0);

        if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
            console.warn('\n❌ 没有可导出的数据');
            alert('没有可导出的数据');
            return;
        }

        // 打印第一条数据的结构
        console.log('\n--- 数据结构分析 ---');
        console.log('第一条数据:', JSON.stringify(dataToExport[0], null, 2));
        console.log('字段名列表:', Object.keys(dataToExport[0] || {}));

        // 纸品类型枚举转换
        const paperTypeMap: Record<string, string> = {
            'COPY': '复印纸',
            'PRINT': '打印纸'
        };

        // 导出纸品类型、子品牌、让利系数、是否发货即开单四个字段
        const excelData = dataToExport.map((item: any) => {
            const paperTypeValue = item.paperType || '';
            const shippingCreateOrderValue =
                item.shippingCreateOrder == null ? '' : (item.shippingCreateOrder ? '是' : '否');
            return {
                '纸品类型': paperTypeMap[paperTypeValue] || paperTypeValue,
                '子品牌': item.subBrand || '',
                '让利系数': item.discountRate ?? '',
                '是否发货即开单': shippingCreateOrderValue
            };
        });

        console.log('\n--- 导出 Excel ---');
        console.log('导出数据预览:', excelData.slice(0, 3));

        exportExcelFile(excelData, {
            filename: `申请月度纸品让利系数明细_${Date.now()}.xlsx`
        });

        console.log('\n========================================');
        console.log('✅ 导出完成!');
        console.log('========================================\n');
    } catch (error) {
        console.error('\n❌ 导出失败:', error);
        alert('导出失败: ' + (error as Error).message);
    }
};

// 注册1: 覆盖 $$internal_ReloadData action
@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType: ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_ReloadData',
        model: 'deli.aries.trade.DeliAriesPaperDiscountRateDetail',
        widget: 'ClientAction'
    })
)
export class PaperRebateCoefficientExport_ReloadData extends ReloadViewActionWidget {
    public initialize(props: any): this {
        super.initialize({ ...props });
        return this;
    }

    public async clickAction(): Promise<void> {
        await handleExport(this);
        this.refreshCallChaining?.syncCall(false);
    }

    @Widget.Reactive()
    public get disabled() {
        return false;
    }
}
